<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<h1 class="title">Her Finest Hour</h1>
<p class="subtitle">One Teen’s Personal War with Hitler’s Germany</p>
<p class="author">Stephen Doster</p>
<p class="author"><img src="images/logo.jpg"/></p>
<a id="page_ii"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?eaef874e